function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* ========================================================================
 * Apricot's Spinner
 * ======================================================================== */

// SCSS
import "../scss/includes/apricot-base.scss";
import "../scss/includes/spinner.scss";

// javaScript
import Utils from "./CBUtils";

/**
 * Animated Spinner
 *
 * @export
 * @param {Object} data
 * @param {Element} data.elem
 * @param {Number} data.min
 * @param {Number} data.max
 * @param {Number} data.end
 * @param {Number} data.duration
 * @param {String} data.suffix
 * @param {Function} data.callBack
 * @returns {{destroy: Function}}
 */

var Animated = function Animated() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultData = {
    elem: null,
    min: 0,
    max: 100,
    end: 100,
    duration: 20000,
    suffix: "%",
    callBack: null
  };
  data = _objectSpread(_objectSpread({}, defaultData), data);
  var min = data.min;
  var max = data.max;
  var elem = data.elem;
  var end = data.end;
  var duration = data.duration;
  var startTimestamp = null;
  var indicator = null;
  var init = function init() {
    elem.counter = "cb";
    indicator = elem.querySelector(".cb-spinner-indicator");

    // A11Y
    Utils.attr(elem, "aria-valuemin", "".concat(min));
    Utils.attr(elem, "aria-valuemax", "".concat(max));
    Utils.attr(elem, "aria-valuenow", "".concat(min));
    Utils.attr(elem, "aria-valuetext", "".concat(end, "%"));
    if (Utils.reduceMotionChanged()) {
      duration = 0;
    }
    window.requestAnimationFrame(step);
  };
  var step = function step(timestamp) {
    if (!startTimestamp) startTimestamp = timestamp;
    var progress = Math.min((timestamp - startTimestamp) / duration, 1);
    var newValue = Math.floor(progress * (end - min) + min);
    if (Utils.reduceMotionChanged()) {
      newValue = end;
    }
    indicator.innerHTML = "".concat(newValue).concat(data.suffix);
    Utils.attr(elem, "aria-valuenow", newValue);
    if (progress < 1) {
      window.requestAnimationFrame(step);
    } else {
      if (data.callBack) {
        data.callBack(elem);
      }
    }
  };
  var destroy = function destroy() {
    if (elem.counter === "cb") {
      elem.counter = null;
      Utils.removeAttr(elem, "aria-valuemin");
      Utils.removeAttr(elem, "aria-valuemax");
      Utils.removeAttr(elem, "aria-valuenow");
    }
  };
  if (elem.tabs !== "cb") {
    init();
  }
  return {
    destroy: destroy
  };
};

/**
 * Progress Indicator
 *
 * @export
 * @param {Object} data
 * @param {Element} data.elem
 * @param {Number} data.end
 * @param {Number} data.duration
 * @param {String} data.suffix
 * @param {Function} data.callBack
 * @returns {{destroy: Function}}
 */

var Progress = function Progress() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultData = {
    elem: null,
    end: 100,
    duration: 800,
    suffix: "%",
    callBack: null
  };
  data = _objectSpread(_objectSpread({}, defaultData), data);
  var elem = data.elem;
  var end = data.end;
  var duration = data.duration;
  if (!Utils.elemExists(elem)) return null;
  var init = function init() {
    elem.progress = "cb";
    var indicator = elem.querySelector(".cb-spinner-indicator");
    var left = elem.querySelector(".cb-spinner-left");
    var right = elem.querySelector(".cb-spinner-right");
    var rotate = elem.querySelector(".cb-spinner-rotate");
    indicator.innerHTML = "".concat(end).concat(data.suffix);
    Utils.attr(elem, "aria-label", "".concat(end).concat(data.suffix, " complete"));
    if (Utils.reduceMotionChanged()) {
      duration = 0;
    }

    //  add a minor delay
    setTimeout(function () {
      rotate.style.transition = "transform " + duration + "ms linear";
      rotate.style.transform = "rotate(" + end * 3.6 + "deg)";
    }, 1);
    if (end > 50) {
      right.style.animation = "toggle ".concat(duration / end * 50, "ms step-end");
      right.style.opacity = 1;
      left.style.animation = "toggle ".concat(duration / end * 50, "ms step-start");
      left.style.opacity = 0;
    }
    if (data.callBack) {
      data.callBack(elem);
    }
  };

  // Remove
  var destroy = function destroy() {
    if (elem.progress === "cb") {
      elem.progress = null;
    }
  };
  if (elem.progress !== "cb") {
    init();
  }
  return {
    destroy: destroy
  };
};
var CBSpinner = {
  Animated: Animated,
  Progress: Progress
};
export default CBSpinner;